import { ActionContext }                            from 'vuex';
import { ErrorReason, LoginError, LoginFormFields } from '@/views/login/login.types';
import { loginUser }                                from '@/views/login/service/login.service';
import { State }                                    from '@/views/login/store/state.store';
import { handleClientBasicError }                   from '@/helpers/helpers';
import { Notification }                             from '@/components/notification/notification';
import i18n                                         from '@/i18n';
import { RootState }                                from '@/store/store.types';
import useGlobalTranslations                        from '@/hooks/use-global-translations';

export default {
  async loginUser(context: ActionContext<State, RootState>, form: LoginFormFields): Promise<void> {
    try {
      context.commit('setLoginErrors');
      window.localStorage.removeItem('hotelUuid');
      window.localStorage.removeItem('prousali');
      await loginUser(form);
      await context.dispatch('user/getUserData', {}, { root: true });

      Notification.success(
        useGlobalTranslations('success.success'),
        i18n.t('vLogin.form.success.loggedIn'),
      );
    } catch (e) {
      context.commit('setLoginErrors', e.response.data);
      if (e.response.data.some((error: LoginError) => error.reason === ErrorReason.BAD_CREDENTIALS)) {
        Notification.error(
          i18n.t(`${context.rootState.i18n.GLOBAL_PATH}.errors.error`),
          i18n.t('vLogin.form.errors.BAD_CREDENTIALS'),
        );
      }
      if (e.response.data.some((error: LoginError) => error.reason === ErrorReason.USER_DISABLED)) {
        Notification.error(
          i18n.t(`${context.rootState.i18n.GLOBAL_PATH}.errors.error`),
          i18n.t('vLogin.form.errors.USER_DISABLED'),
        );
      }
      throw Error;
    }
  },
  async checkCookiePolicy(context: ActionContext<State, RootState>): Promise<void> {
    try {
      const cookies: { [ key: string ]: string } = document.cookie
        .split(';')
        .map((cookie) => cookie.split('='))
        .reduce((acumulator, [ key, value ]) => ({ ...acumulator, [ key.trim() ]: decodeURIComponent(value) }), {});

      if (Object.prototype.hasOwnProperty.call(cookies, 'cookiePolicy')) {
        context.commit('setCookiePolicy', true);
      }
    } catch (e) {
      handleClientBasicError(e);
    }
  },
};
